// extracted by mini-css-extract-plugin
export var productInsurance = "ProductInsurance-module--product-insurance--2957e";
export var productInsuranceContainer = "ProductInsurance-module--product-insurance-container--9839c";